import React, { useEffect } from 'react'

import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm } from 'react-hook-form'

import FinalizeTaskDialog from '../../FinalizeTaskController/FinalizeTaskDialog'
import { genericOpinionSchema } from '../GenericOpinionTask/GenericOpinionSchema'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import useSubmitTask from 'hooks/useSubmitTask'
import { GenericOpinionTaskFields } from '../GenericOpinionTask/GenericOpinionTask'

import TaskHeaderController from 'controllers/TaskManager/TaskSubControllers/TaskHeader/TaskHeader'
import AlertBox from 'components/AlertBox/AlertBox'

import styles from '../../Dialog.module.sass'
import TaskMenuController from '../../TaskMenu/TaskMenuController'

const RelapseOpinionTaskController = (props) => {
	const { data, dismiss, id, resolve } = props
	const { i18n } = useGlobal()

	const methods = useForm({
		mode: 'onSubmit',
		resolver: zodResolver(genericOpinionSchema),
		shouldUnregister: true,
	})
	const { handleSubmit, formState, reset, getValues } = methods

	const { error, submitting, approveTask } = useSubmitTask(
		data?.id,
		formState?.errors
	)

	const onSubmit = (data) => {
		approveTask(data, 'submit')
			.then(() => resolve())
			.catch(() => {})
	}

	const customError = error?.map((err) => {
		return {
			title: i18n`Error`,
			text: err,
		}
	})

	useEffect(() => {
		if (
			data.formState &&
			!formState.isDirty &&
			formState.submitCount === 0
		) {
			reset && data.formState && reset(data.formState)
		}
	}, [reset, data.formState, formState.isDirty, formState.submitCount])

	return (
		<>
			{submitting && (
				<FinalizeTaskDialog
					dismiss={dismiss}
					submitting={submitting}
					task={data}
				/>
			)}
			<FormProvider {...methods}>
				<div className={styles['form-container']}>
					<TaskHeaderController task={data} />
					<form
						id={`form_${id}`}
						className={styles['form']}
						onSubmit={handleSubmit(onSubmit)}
					>
						{customError && customError.length > 0 && (
							<AlertBox
								className={styles['alert-box']}
								type='error'
								items={customError}
							/>
						)}
						<GenericOpinionTaskFields data={data} />
					</form>
				</div>
			</FormProvider>
			<TaskMenuController
				data={{
					formId: id,
					options: ['postpone', 'forward'],
					submitting,
					submissionType: 'submit',
					getValues,
				}}
			/>
		</>
	)
}

export default RelapseOpinionTaskController
